import type * as React from "react";

interface Props {
	name: string;
	dir?: string;
	className?: string;
}

const Icon: React.FC<Props> = (props) => {
	const basePath = import.meta.env.BASE_URL || "/";
	const cleanBasePath = basePath.endsWith("/")
		? basePath.slice(0, -1)
		: basePath;
	const src = `${cleanBasePath}/icons/${props.dir ? `${props.dir}/` : ""}${props.name}.svg`;
	return <img src={src} className={props.className} alt={props.name} />;
};

export default Icon;
